import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enumToNumberArray' })
export class EnumToArrayPipe implements PipeTransform {
    transform(enumObj): string[] {
        return Object.keys(enumObj);
    }
}
